import { NavLink } from 'react-router-dom';

import Chip from '@zenbusiness/zui/Chip';
import ZuiLink from '@zenbusiness/zui/Link';
import ZuiStack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import ZuiText from '@zenbusiness/zui/Text';

export const EntityInfo = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'EntityInfo',
  tag: ZuiStack,
  styles: {
    flex: 1,
    minWidth: 0,
  },
});

export const Jurisdiction = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'Jurisdiction',
  tag: ZuiText,
  styles: ({ theme }) => ({
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
    marginLeft: theme.spacing(0.2),
  }),
});

export const Link = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'EntityMenuItemLink',
  tag: ZuiLink,
  propsAdded: {
    component: NavLink,
  },
  styles: ({ theme }) => ({
    display: 'flex',
    gap: '0.75rem',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    lineHeight: '1.5',
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },

    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
    },
  }),
});

export const EntityName = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'EntityName',
  tag: ZuiText,
  styles: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
});

export const Pill = superstyled({
  name: 'BusinessEntitySelector',
  slot: 'EntityMenuItemChip',
  tag: Chip,
  propsAdded: {
    color: 'warning',
  },
  styles: {
    padding: '2px 6px',
    borderRadius: 18,
    textTransform: 'uppercase',
  },
});
